import { IParamsToSend } from '@base/@types/providers/Alert/FollowUpProvider'

export const followUpRequest: IParamsToSend = {
  empresa: {
    ids: [],
    agrupar: false
  },
  loja: {
    ids: [],
    agrupar: false
  },
  tipoCentro: {
    descricoes: [],
    agrupar: false
  },
  gerenteCategoria: {
    ids: [],
    agrupar: false
  },
  gerenteProduto: {
    ids: [],
    agrupar: false
  },
  mundo: {
    ids: [],
    agrupar: false
  },
  categoriaCompacta: {
    ids: [],
    agrupar: false
  },
  tipoPedido: {
    descricoes: [],
    agrupar: false
  },
  pedidos: {
    descricoes: [],
    agrupar: false
  },
  fornecedor: {
    ids: [],
    agrupar: true
  },
  produto: {
    ids: [],
    agrupar: false
  },
  subCategoria: {
    ids: [],
    agrupar: true
  },
  periodo: {
    inicio: new Date().toISOString(),
    final: new Date().toISOString(),
    agrupar: false
  }
}
